





























import { CrudService } from '@/data/services/crud.service';
import { Component, Vue, Inject, Ref, Watch, Prop } from 'vue-property-decorator';
import { Actor, ActorTypes } from '@/data/models/actor.model';
import AttoreFilter from './AttoreFilter.vue';
import AttoreList from './AttoreList.vue';
import store, { State } from '@/store';
import { Search } from '@/data/models/search.model';
import { Volunteer } from '@/data/models/volunteer.model';
import { Associate } from '@/data/models/associate.model';
import { Patient } from '@/data/models/patient.model';
import { Doctor } from '@/data/models/doctor.model';

@Component({
	components: { AttoreFilter, AttoreList },
})
export default class Attori extends Vue {

	@Prop() entityfilter!: string;
	@Inject('CrudService') crudService!: CrudService<Actor>;
	@Inject('CrudService') volunteerCrudService!: CrudService<Volunteer>;
	@Inject('CrudService') associateCrudService!: CrudService<Associate>;
	@Inject('CrudService') patientCrudService!: CrudService<Patient>;
	@Inject('CrudService') doctorCrudService!: CrudService<Doctor>;

	@Ref('list') list!: AttoreList;
	@Ref('filter') filter!: AttoreFilter;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	@Watch('state.headquarter', { deep: true })
	onHQChange() {
		this.filter.reset();
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.loadCampagne();
	}

	newActor() {
		if(!this.entityfilter) {
			this.$router.push('/attori/new');
		} else {
			this.$emit('newClicked');
		}
	}

	onRenewCard(event: Actor) {
		this.$emit('renewcard', event);
	}

	editActor(item: Actor) {
		let tab = 0;
		switch(this.entityfilter) {
		case ActorTypes.VOLUNTEER: 
			tab = 1;
			break;
		case ActorTypes.ASSOCIATE: 
			tab = 2;
			break;
		case ActorTypes.PATIENT: 
			tab = 3;
			break;
		case ActorTypes.DOCTOR: 
			tab = 4;
			break;
		}
		this.$router.push(`/attori/${item.id}/edit?tab=${tab}`);
	}

	saveActor(item: Actor) {
		this.crudService.saveEntity(Actor, 'actor', item).then(() => {
			this.$buefy.notification.open({
				message: this.$t(`${this.entityfilter}-deleted`).toString(),
				type: 'is-success',
			});
		});
	}

	deleteActor(item: Actor) {
		if(!this.entityfilter) {
			this.$buefy.dialog.confirm({
				message: this.$t('warning-person-delete') as string,
				type: 'is-danger',
				hasIcon: true,
				cancelText: this.$t('annulla') as string,
				onConfirm: () => {
					this.crudService
						.deleteEntity(Actor, 'actor', item)
						.then(() => {
							this.list.loadCampagne();
						})
						.catch((error) => {
							this.$buefy.notification.open({
								message: error.msg,
								type: 'is-danger',
							});
						});
				},
			});
		} else{
			this.deleteEntity(item);
		} 
	}

	deleteEntity(item: Actor) {
		let entity: any;
		let service: any;
		let classType: any ;

		switch(this.entityfilter) {
		case ActorTypes.VOLUNTEER: 
			entity = item.volunteer;
			service = this.volunteerCrudService;
			classType = Volunteer;
			item.volunteerid = undefined;
			break;
		case ActorTypes.ASSOCIATE: 
			entity = item.associate;
			service = this.associateCrudService;
			classType = Associate;
			item.associateid = undefined;
			break;
		case ActorTypes.PATIENT: 
			entity = item.patient;
			service = this.associateCrudService;
			classType = Patient;
			item.patientid = undefined;
			break;
		case ActorTypes.DOCTOR: 
			entity = item.doctor;
			service = this.doctorCrudService;
			classType = Doctor;
			item.doctorid = undefined;
			break;
		}
		this.$buefy.dialog.confirm({
			message: this.$t(`warning-${this.entityfilter}-delete`) as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				service
					.deleteEntity(classType, this.entityfilter, entity)
					.then(() => {
						this.saveActor(item);
						this.list.loadCampagne();
					});
			},
		});
	}
}
